export default class Geo {
  static calcDistanceKm (pos1, pos2) {
    const radLat1 = Geo.toRadian(pos1.latitude)
    const radLon1 = Geo.toRadian(pos1.longitude)
    const radLat2 = Geo.toRadian(pos2.latitude)
    const radLon2 = Geo.toRadian(pos2.longitude)

    const radLatDiff = radLat1 - radLat2
    const radLonDiff = radLon1 - radLon2

    const a = Math.pow(Math.sin(radLatDiff), 2) + (
      Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(radLonDiff / 2), 2)
    )
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const metres = c * 6371e3
    return metres / 1000
  }

  static toRadian (degree) {
    return degree * (Math.PI / 180)
  }
}